import React from 'react';
import './RateCur.css';
import Money from "../../img/money.svg";

class RateCur extends React.Component {
    render() {
        return (
            <div className="col-xl-4 rate lite-shadow">
                <div className="top-section">
                    <div className="currency">{this.props.ccy}</div>
                    <div className="value"><span><img alt="arrow" src={Money}/></span>
                        <div className="cost">{Number(this.props.buy).toFixed(2)}</div>
                    </div>
                </div>
                <div className="main-section">
                    <div className="line"><span>Купівля</span><span className="cur-cost">{Number(this.props.buy).toFixed(2)}</span></div>
                    <div className="line"><span>Продажа</span><span className="cur-cost">{Number(this.props.sale).toFixed(2)}</span></div>
                </div>
            </div>
        )
    }
}

export default RateCur;